import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { baseurl } from "../../../component/Baseurl";

function CommitBooking({ adt, chd }) {
  const { token } = useParams();
  const [passengers, setPassengers] = useState([]);
  const [contactDetails, setContactDetails] = useState({
    CountryName: "India",
    ContactNo: "",
    City: "",
    PinCode: "",
    AddressLine1: "",
    Email: "",
  });

  useEffect(() => {
    const generatePassengers = () => {
      let tempPassengers = [];

      const createPassenger = (type, index) => ({
        type,
        index,
        Title: "",
        FirstName: "",
        LastName: "",
        Gender: "",
        DateOfBirth: "", 
        ...contactDetails, // Apply shared details
      });

      for (let i = 0; i < (adt && adt !== "N/A" ? parseInt(adt) : 0); i++) {
        tempPassengers.push(createPassenger("Adult", i + 1));
      }

      for (let i = 0; i < (chd && chd !== "N/A" ? parseInt(chd) : 0); i++) {
        tempPassengers.push(createPassenger("Child", i + 1));
      }

      setPassengers(tempPassengers);
    };

    generatePassengers();
  }, [adt, chd]);

  const handlePassengerChange = (index, field, value) => {
    setPassengers((prev) =>
      prev.map((p, i) => (i === index ? { ...p, [field]: value } : p))
    );
  };

  const handleContactChange = (field, value) => {
    setContactDetails((prev) => ({ ...prev, [field]: value }));

    setPassengers((prev) =>
      prev.map((p) => ({
        ...p,
        [field]: value,
      }))
    );
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    for (const passenger of passengers) {
      for (const key in passenger) {
        if (key !== "type" && key !== "index" && !passenger[key]) {
          alert(`Please fill in all fields for ${passenger.type} ${passenger.index}`);
          return;
        }
      }
    }

    const payload = {
      ResultToken: token,
      passengers,
    };

    console.log("Sending Payload:", JSON.stringify(payload, null, 2));

    try {
      const response = await axios.post(`${baseurl}commitFlightBooking`, payload, {
        headers: {
          "Content-Type": "application/json",
        },
      });

      console.log("Response from backend:", response.data);
      alert("Booking submitted successfully!");
    } catch (error) {
      console.error("Error submitting booking:", error.response?.data || error.message);
      alert(`An error occurred: ${error.response?.data?.message || "Failed to submit booking"}`);
    }
  };

  return (
    <div className="container mt-4 text-start mb-5">
      <h2>Passenger Details</h2>
      <form onSubmit={handleSubmit} className="text-start">
        {passengers.map((passenger, index) => (
          <div key={index} className="border p-3 mb-3 rounded">
            <h4>{passenger.type} {passenger.index}</h4>
            <div className="row g-3">
              <div className="col-md-4">
                <label>Title:</label>
                <select className="form-control input1" required value={passenger.Title} onChange={(e) => handlePassengerChange(index, "Title", e.target.value)}>
                  <option value="">Select</option>
                  <option value="Mr">Mr</option>
                  <option value="Mrs">Mrs</option>
                  <option value="Miss">Miss</option>
                </select>
              </div>

              <div className="col-md-4">
                <label>First Name:</label>
                <input type="text" className="form-control input1" required value={passenger.FirstName} onChange={(e) => handlePassengerChange(index, "FirstName", e.target.value)} />
              </div>

              <div className="col-md-4">
                <label>Last Name:</label>
                <input type="text" className="form-control input1" required value={passenger.LastName} onChange={(e) => handlePassengerChange(index, "LastName", e.target.value)} />
              </div>

              <div className="col-md-4">
                <label>Gender:</label>
                <select className="form-control input1" required value={passenger.Gender} onChange={(e) => handlePassengerChange(index, "Gender", e.target.value)}>
                  <option value="">Select</option>
                  <option value="Male">Male</option>
                  <option value="Female">Female</option>
                </select>
              </div>

              <div className="col-md-4">
                <label>Date of Birth:</label>
                <input type="date" className="form-control input1" required value={passenger.DateOfBirth} onChange={(e) => handlePassengerChange(index, "DateOfBirth", e.target.value)} />
              </div>
            </div>
          </div>
        ))}

        <h3>Other Details</h3>
        <div className="row g-3">
        <div className="col-md-4">
            <label>Email:</label>
            <input type="email" className="form-control input1" required value={contactDetails.Email} onChange={(e) => handleContactChange("Email", e.target.value)} />
          </div>

          <div className="col-md-4">
            <label>Contact No:</label>
            <input type="tel" className="form-control input1" required value={contactDetails.ContactNo} onChange={(e) => handleContactChange("ContactNo", e.target.value)} />
          </div>


          <div className="col-md-12">
            <label>Address Line 1:</label>
            <input type="text" className="form-control input1" required value={contactDetails.AddressLine1} onChange={(e) => handleContactChange("AddressLine1", e.target.value)} />
          </div>


          <div className="col-md-4">
            <label>City:</label>
            <input type="text" className="form-control input1" required value={contactDetails.City} onChange={(e) => handleContactChange("City", e.target.value)} />
          </div>

          <div className="col-md-4">
            <label>Country Name:</label>
            <input type="text" className="form-control input1" required value={contactDetails.CountryName} onChange={(e) => handleContactChange("CountryName", e.target.value)} />
          </div>

         

          

          <div className="col-md-4">
            <label>Pin Code:</label>
            <input type="text" className="form-control input1" required value={contactDetails.PinCode} onChange={(e) => handleContactChange("PinCode", e.target.value)} />
          </div>

          

          
        </div>

        <button type="submit" className="btn btn-primary mt-3 mb-5">Confirm Booking</button>
      </form>
    </div>
  );
}

export default CommitBooking;
